<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Search Results</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Search Results</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<section *ngIf="searchData" class="profile-area profile-area-two pt-100">
  <div class="container">
    <!-- Option 1: The below works perfectly -->
      <!-- <div *ngFor="let x of _services" class="row">
          <div *ngIf="x.city.toLowerCase().includes(searchData.city) && x.name.toLowerCase().includes(searchData.category) || x.serviceCategory.name.toLowerCase().includes(searchData.category)"
            class="col-sm-6 col-lg-3">
              <div class="profile-item wow fadeInUp" data-wow-delay=".3s">
                  <img src="assets/img/home/service_img_holder.jpg" alt="Profile">

                  <div class="profile-inner">
                      <h3>{{x.name}}</h3>
                      <span>{{x.line}}</span>
                      <a routerLink="/service_detail">View<i class="icofont-swoosh-right"></i></a>
                      <div class="profile-heart">
                          <a routerLink="/service_detail"><i class="icofont-heart-alt"></i></a>
                      </div>
                  </div>
              </div>
          </div>
      </div> -->

      <!-- Option 2:  -->
      <div *ngIf="searchResults" class="row">
        <div *ngFor="let x of searchResults" class="col-sm-6 col-lg-3">
            <div class="profile-item wow fadeInUp" data-wow-delay=".3s">
                <div class="profile-inner">
                    <h3>{{x.name}}</h3>
                    <span>{{x.line}}</span>
                    <a [routerLink]="['/service_detail', x.id]" (click)="registerRequest(x)">View<i class="icofont-swoosh-right"></i></a>
                    <div class="profile-heart">
                        <a [routerLink]="['/service_detail', x.id]" (click)="registerRequest(x)"><i class="icofont-heart-alt"></i></a>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <div *ngIf="searchResults == 0" class="row">
            <div class="error-item wow fadeInUp" data-wow-delay=".3s">
              <div class="d-table">
                <div class="d-table-cell">
                    <div class="error-text">
                        <h3>OOPs!</h3>
                        <p>Your Search Criteria returned <span class="text-danger">0</span> results</p>
                        <span>Please adjust the criteria and try again.</span>
                        <a routerLink="/">Edit..<i class="icofont-pen-alt-1"></i></a>
                    </div>
                </div>
              </div>
            </div>
      </div>


  </div>
</section>

<section *ngIf="!searchData || searchData == null" class="error-area">
  <div class="error-item">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="error-text">
                  <h3>OOPs!</h3>
                  <p>Search Criteria is not defined</p>
                  <span>Please define your search criteria and try again.</span>
                  <a routerLink="/">Edit..<i class="icofont-pen-alt-1"></i></a>
              </div>
          </div>
      </div>
  </div>
</section>
